import { useState } from "react";


interface MiniCardProps {
    name: string;
    value: number;
    icon: React.ReactNode;
    color?: string
    onClick?: () => void;
}

const MiniCard: React.FC<MiniCardProps> = ({ name, value, icon, color, onClick }) => {

    return (
        <span onClick={onClick} className="mini-card">
            <div style={{ color: color }}>{icon}</div> 
            <h6 style={{ marginTop: "8px" }}>{name}</h6>
            <h4 style={{ color: color }}>{value}</h4>
        </span>
    );
};

export default MiniCard;